import {JsonObject, JsonProperty} from 'json2typescript';
import {Condition} from './Condition';
import {BooleanOperator} from './BooleanOperator';
import {ConditionArrayConverter} from '../../customJsonConverters/ConditionArrayConverter';

@JsonObject('MultipleCondition')
export class MultipleCondition implements Condition {

    @JsonProperty('booleanOperator',String)
    private booleanOperator = 'AND';

    @JsonProperty('conditionClass',String)
    conditionClass = '';

    @JsonProperty('conditions',ConditionArrayConverter)
    private conditions:Array<Condition> = [];

    @JsonProperty('type',String)
    type = '';



    public MultipleCondition() {
        this.conditionClass='multiple';
    }


    public getBooleanOperator():BooleanOperator {
       switch (this.booleanOperator) {
           case 'AND':return BooleanOperator.AND;
           case 'OR': return  BooleanOperator.OR;
           case 'XOR': return BooleanOperator.XOR;
       }
    }

    public setBooleanOperator(booleanOperator:BooleanOperator):void {
        this.booleanOperator = BooleanOperator[booleanOperator];
    }

    getConditionClass():string {
        return this.conditionClass;
    }

    setConditionClass(conditionClass:string):void {
        this.conditionClass = conditionClass;
    }

    addCondition(cond:Condition) {
        this.conditions.push(cond);
    }

    getConditions():Array<Condition> {
        return this.conditions;
    }

    /*getType():string {
        return this.type;
    }

    setType(type:string):void {
        this.type = type;
    }*/

}
